import { Row, StyledDigestNotificationContainer } from './utils'
import { Box } from '@mui/material'
import { TimeRangeSelector } from './TimeRangeSelector'

export const NotificationControlWithDaySelector = (props: any) => {
    const {
        label,
        description,
        noOfDays,
        handleChange,
        handleUpdate,
        active,
        loading,
    } = props

    return (
        <>
            <StyledDigestNotificationContainer>
                <Row
                    active={active}
                    label={label}
                    description={description}
                    onChange={handleUpdate}
                    loading={loading}
                />
            </StyledDigestNotificationContainer>
            {active && (
                <Box padding="16px">
                    <TimeRangeSelector
                        noOfDays={noOfDays}
                        handleChange={handleChange}
                        loading={loading}
                    />
                </Box>
            )}
        </>
    )
}
